import { InputSwitch } from "primereact/inputswitch"
import "./index.scss"

const Switch = ({
  checked,
  handleChange,
  color,
  style,
  ...props
}: $TSMigrationFixMe) => {
  return (
    <div>
      <div className='switch'>
        <InputSwitch
          checked={checked}
          onChange={handleChange}
          style={{ color, ...style }}
          {...props}
        />
      </div>
    </div>
  )
}
export default Switch
